import { useUser } from "components/clerk";
import { Stack } from "expo-router";
import React from "react";
import { useIsMobile } from "utils/hooks/useIsMobile";
export default function MainLayout() {
	let { isLoaded } = useUser();
	const isMobile = useIsMobile();

	if (!isLoaded) {
		return null;
	}

	return (
		<Stack
			screenOptions={{
				headerShown: false,
				headerBackVisible: true,
				animation: "slide_from_right",
			}}
		></Stack>
	);
}
